@if (!cardStylesArray) {
    <div class="container" [ngClass]="{'dialog-background': sopoDialogRef}">
        <ng-container *ngIf="(mycardStyles$ | async) && (activeCardStyle$ | async); else loading">
            <div
                *ngFor="let card of (mycardStyles$ | async); trackBy: trackCards"
                (click)="onSelect(card)"
                [ngClass]="{'item-border' : (activeCardStyle$ | async).value === card.value}"
            >
                <div class="wrapper">
                    <img [src]="getCard(card.value)"/>
                    <label>{{ card.name }}</label>
                </div>
            </div>
        </ng-container>
    </div>

    <ng-template #loading>
        <sopo-loader-dots [type]="'two'"></sopo-loader-dots>
    </ng-template>
} @else {
    <swiper
        cards_swiper
        [config]="sliderOptions"
        class="swiper"
        #cardSlide
    >
        <ng-template
            swiperSlide
            *ngFor="let card of (mycardStyles$ | async); trackBy: trackCards"
        >
            <div
                class="wrapper"
                (click)="onSelect(card)"
            >
                <img [src]="getCard(card.value)" [ngClass]="{'item-border' : (activeCardStyle$ | async)?.value === card.value}"/>
                <label class="name-tag">{{ card.name }}</label>
            </div>
        </ng-template>
    </swiper>
}
